<template>
  <div>
    <section class="nologin-section">
      <div class="nologin-header">
        <h1>
          <img src="@/assets/images/common/job_logo_1024.png" id="job-logo" alt="bib logo" />
        </h1>
      </div>
      <slot />
      <!-- <p class="footer_txt text-center">Copyright © 2020 BIBJOB - All Rights Reserved.</p> -->
    </section>
    <p class="footer_txt text-center">Copyright © BIB Co., Ltd. All rights reserved.</p>
  </div>
</template>

<script>
export default {
  name: 'NoLoginLayout'
}
</script>